import { Capacitor } from '@capacitor/core';
import { Filesystem } from '@capacitor/filesystem';
import { isNativePlatform } from './platformService.js';

export function getAudioUploadMode() {
  return isNativePlatform() ? 'native-file-form-data' : 'web-form-data';
}

export async function nativeRecordingToBlob(recording) {
  if (!recording?.filePath) throw new Error('Native recording is missing its file path.');
  const response = await fetch(Capacitor.convertFileSrc(recording.filePath));
  if (!response.ok) throw new Error('Could not read the native audio file.');
  const blob = await response.blob();
  console.info('[native-audio] file blob', {
    filePath: recording.filePath,
    fileName: recording.fileName,
    expectedMime: recording.mime,
    blobType: blob.type,
    blobSize: blob.size,
  });
  if (recording.mime && blob.type !== recording.mime) {
    return new Blob([blob], { type: recording.mime });
  }
  return blob;
}

function nativeDeletePaths(filePath) {
  if (!filePath) return [];
  const paths = [filePath];
  if (filePath.startsWith('file://')) {
    paths.push(filePath.replace(/^file:\/\//, ''));
  }
  return [...new Set(paths.map((path) => {
    try {
      return decodeURI(path);
    } catch {
      return path;
    }
  }))];
}

export async function deleteNativeRecordingFile(recording) {
  if (!isNativePlatform() || !recording?.filePath) return false;

  let lastError = null;
  for (const path of nativeDeletePaths(recording.filePath)) {
    try {
      await Filesystem.deleteFile({ path });
      console.info('[native-audio] file cleanup', {
        filePath: recording.filePath,
        deletePath: path,
        fileName: recording.fileName,
      });
      return true;
    } catch (err) {
      lastError = err;
    }
  }

  console.warn('[native-audio] file cleanup skipped', {
    filePath: recording.filePath,
    fileName: recording.fileName,
    message: lastError?.message || String(lastError || 'Unknown cleanup error'),
  });
  return false;
}

export async function cleanupNativeRecordingFiles(recordings = []) {
  await Promise.all(recordings.map((recording) => deleteNativeRecordingFile(recording)));
}
